export const GEAR_TYPE_POLICY_MODAL_DISMISSED_KEY = 'gearTypePolicyModalDismissed_v2';

export function isGearTypePolicyModalDismissed(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(GEAR_TYPE_POLICY_MODAL_DISMISSED_KEY) === 'true';
}

export function dismissGearTypePolicyModal() {
  if (typeof window === 'undefined') return;
  localStorage.setItem(GEAR_TYPE_POLICY_MODAL_DISMISSED_KEY, 'true');
}
